import SLOT_STATUS from "constants/slot-status";
import { ensureArray } from "helpers/type-checkers";
import { createSelector } from "reselect";

const selectGameState = (state) => state.game;

export const selectLevel = createSelector(
  selectGameState,
  (game) => game.selectedLevel
);

export const selectCodesGrid = createSelector(
  selectGameState,
  (game) => game.codes
);

export const selectRemainingHealth = createSelector(
  selectGameState,
  (game) => game.remainingHealth
);

export const selectTimeIsUp = createSelector(
  selectGameState,
  (game) => game.timeIsUp
);

export const selectScore = createSelector(
  selectGameState,
  (game) => game.score
);

export const selectSlots = createSelector(
  selectGameState,
  (game) => game.slots
);

export const selectItems = createSelector(
  selectGameState,
  (game) => game.items
);

export const selectIsGameStarted = createSelector(
  selectLevel,
  (level) => level !== null
);

export const selectPlayCount = createSelector(
  selectGameState,
  (game) => game.playCount
);

export const selectShuffledItems = createSelector(
  selectGameState,
  (game) => game.shuffled
);

export const selectSlotRanOut = createSelector(selectSlots, (slots) => {
  if (Array.isArray(slots)) {
    return slots.every((slot) => {
      const slotLength = slot.length;
      if (slotLength === 0) return true;
      return !Boolean(slot[slotLength - 1]?.item);
    });
  }
  return false;
});

export const selectIsGameOver = createSelector(
  selectTimeIsUp,
  selectRemainingHealth,
  selectSlotRanOut,
  (timeIsUp, remainingHealth, shuffledRanOut) =>
    timeIsUp || remainingHealth === 0 || shuffledRanOut
);

export const selectWhyGameOver = createSelector(
  selectTimeIsUp,
  selectRemainingHealth,
  selectSlotRanOut,
  (timeIsUp, remainingHealth, shuffledRanOut) => {
    if (timeIsUp) return "Vaxt bitdi";
    if (remainingHealth === 0) return "Cəhdlər bitdi";
    if (shuffledRanOut) return "Məhsullar bitdi";
    return null;
  }
);

export const selectUserProgress = createSelector(
  selectLevel,
  selectScore,
  selectRemainingHealth,
  (level, score, remainingHealth) => ({
    health: level?.health,
    score,
    remainingHealth,
  })
);

export const selectSlot = (index) =>
  createSelector(selectSlots, (slots) => {
    if (Array.isArray(slots) && slots.length > index) return slots[index];
    return [{}];
  });

export const selectCodeStatus = createSelector(
  selectGameState,
  (game) => game.codeStatus
);

export const selectLocalBest = createSelector(
  selectGameState,
  (game) => game.localBest
);

export const selectFlatSlotItems = createSelector(selectSlots, (slots) =>
  slots
    .flat()
    .filter((slot) =>
      [SLOT_STATUS.SUCCESS, SLOT_STATUS.FAIL].includes(slot.status)
    )
);
